import React from 'react';

import { type BaseSvgProps, colorToHexCode } from '../../utils';

export const ExpandClose = ({
  width = 27,
  primaryColorHexCode = colorToHexCode.black,
  'data-testid': testId,
}: BaseSvgProps) => (
  <svg
    data-testid={testId}
    width={width}
    height={width}
    viewBox="0 0 27 27"
    className="shrink-0"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.9467 6.6533L15.9467 10.4533L20.4 5.99997L21.1333 6.7333L16.68 11.1866L20.48 11.1866L20.48 12.1333L15 12.1333L15 6.6533L15.9467 6.6533Z"
      fill={primaryColorHexCode}
    />
    <path
      d="M11.1866 20.48L11.1866 16.68L6.7333 21.1333L5.99997 20.4L10.4533 15.9467L6.6533 15.9467L6.6533 15L12.1333 15L12.1333 20.48L11.1866 20.48Z"
      fill={primaryColorHexCode}
    />
  </svg>
);
